var React = require('react');

function FirstAid (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M64 480h64V32H64zM448 32v448h64V32z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M128 480h320V32H128zm64-248a8 8 0 0 1 8-8h56v-56a8 8 0 0 1 8-8h48a8 8 0 0 1 8 8v56h56a8 8 0 0 1 8 8v48a8 8 0 0 1-8 8h-56v56a8 8 0 0 1-8 8h-48a8 8 0 0 1-8-8v-56h-56a8 8 0 0 1-8-8zM0 80v352a48 48 0 0 0 48 48h16V32H48A48 48 0 0 0 0 80zm528-48h-16v448h16a48 48 0 0 0 48-48V80a48 48 0 0 0-48-48z","className":"fa-primary","key":2})]);
}

FirstAid.defaultProps = {"viewBox":"0 0 576 512","className":"icon"};

module.exports = FirstAid;

FirstAid.default = FirstAid;
